import { Routes } from '@angular/router';
import { FlowNavigatorService } from './ks-onboarding/services/flow-navigator.service';
import { OnboardingNextScreenCommand } from './ks-onboarding/commands/onboarding-next-screen.command';
import { CreateInitialEntitiesCommand } from './ks-onboarding/commands/create-initial-entities.command';
import { OnboardingDataResolver } from './ks-onboarding/onboarding-reslover';
import { onboardingGuard } from './ks-onboarding/onboarding.guard';
import { OnboardingPreviousScreenCommand } from './ks-onboarding/commands/onboarding-previous-screen-command';
import { RecommendedFundService } from './ks-onboarding/services/recommended-fund/recommended-fund.service';

export const routes: Routes = [
  {
    path: 'kiwisaver/onboarding',
    title: 'KiwiSaver Onboarding',
    loadChildren: () =>
      import('./ks-onboarding/onboarding-routes').then((m) => m.ONBOARDING_ROUTES),
    canActivate: [onboardingGuard],
    providers: [
      OnboardingDataResolver,

      CreateInitialEntitiesCommand,
      OnboardingNextScreenCommand,
      OnboardingPreviousScreenCommand,

      FlowNavigatorService,
      RecommendedFundService,
    ],
  },

  {
    path: 'dashboard',
    title: 'Dashboard',
    loadChildren: () =>
      import('./dashboard/dashboard.routes').then((m) => m.DASHBOARD_ROUTES),
  },

  {
    path: 'login',
    title: 'Login',
    loadChildren: () => import('./login/login.routes').then((m) => m.LOGIN_ROUTES),
  },

  {
    path: 'logout',
    title: 'Logout',
    loadChildren: () => import('./logout/logout.routes').then((m) => m.LOGOUT_ROUTES),
  },

  {
    path: 'reset-password',
    title: 'Reset Password',
    loadChildren: () =>
      import('./reset-password/reset-password.routes').then((m) => m.RESET_PASSWORD_ROUTES),
  },

  {
    path: 'admin',
    title: 'Admin',
    loadChildren: () => import('./admin/admin.routes').then((m) => m.ADMIN_ROUTES),
  },

  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'kiwisaver/onboarding/flow/goal',
  },

  // Unknown URLs go to the first screen. Must stay last, after every lazy route.
  {
    path: '**',
    redirectTo: 'kiwisaver/onboarding/flow/goal',
  },
];
